import { render } from "./BellIcon.vue?vue&type=template&id=1f7fef2a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BellIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f7fef2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f7fef2a', __exports__)) {
    api.reload('1f7fef2a', __exports__)
  }
  
  module.hot.accept("./BellIcon.vue?vue&type=template&id=1f7fef2a", () => {
    api.rerender('1f7fef2a', render)
  })

}


export default __exports__